import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../../store/selectors';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Loading from '../../utility/Loading';
import TopChosenChart from './TopChosenChart';
import LevelOfEducationLegend from './LevelOfEducationLegend';
import CurrentlyInHighSchoolLegend from './CurrentlyInHighSchoolLegend';
import CSVDownloadMenu from '../reporting-components/CSVDownloadMenu';

export class TopChosen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
      loading: true,
      top25: [],
      top5: [],
      showTop25: false,
      dataToShow: [],
      top25Button: `View Top 25 ${
        reportingCopy.topChosen[this.props.section].keyword
      } +`,
    };

    this.getData = this.getData.bind(this);
    this.getCsv = this.getCsv.bind(this);
  }

  async componentDidMount() {
    const [top25, top5] = await this.getData();

    this.setState({
      top25,
      top5,
      dataToShow: top5,
      loading: false,
    });
  }

  async getData() {
    const top25Obj = await this.props.getTopChosen(this.props.tenant.id, {
      limit: 25,
    });

    const top25 = Object.entries(top25Obj);
    const top5 = top25.slice(0, 5);

    return [top25, top5];
  }

  async getCsv() {
    const csvData = await this.props.getTopChosenCsv(this.props.tenant.id);
    return csvData;
  }

  setShowTop25 = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showTop25: !prevState.showTop25,
        dataToShow: !prevState.showTop25 ? prevState.top25 : prevState.top5,
        top25Button: !prevState.showTop25
          ? `View Fewer ${
              reportingCopy.topChosen[this.props.section].keyword
            } -`
          : `View Top 25 ${
              reportingCopy.topChosen[this.props.section].keyword
            } +`,
      };
    });
  };

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  render() {
    return (
      <div className="top-chosen">
        <div className="top-chosen__header">
          <div className="top-chosen__heading">
            {reportingCopy.topChosen[this.props.section].heading}
          </div>
          <div className="top-chosen__meatball-menu-container">
            <CSVDownloadMenu
              csv={this.getCsv}
              filename={`top-chosen-${
                reportingCopy.topChosen[this.props.section].className
              }`}
            />
          </div>
        </div>
        <div className="top-chosen__subheader">
          <div className="top-chosen__subheading">
            {reportingCopy.topChosen[this.props.section].subheading}
          </div>
          <CurrentlyInHighSchoolLegend />
        </div>
        <LevelOfEducationLegend />
        {this.state.loading ? (
          <Loading height="100%" />
        ) : (
          this.state.dataToShow.map(([category, data]) => {
            return (
              <TopChosenChart
                category={category}
                data={data}
                section={this.props.section}
                key={category}
              />
            );
          })
        )}
        {this.state.top25.length > 5 ? (
          <div className="top-chosen__footer">
            <button
              type="button"
              className="top-chosen__top-25-button"
              style={this.colorPrimary}
              onClick={() => this.setShowTop25()}
            >
              <span>{this.state.top25Button}</span>
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps)(TopChosen);
